import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 7 — Pursuit (brief §6).
 *
 * The first Drifter in real content: a flying chaser, blocked by any solid
 * tile but able to change row to route around one when the player is above
 * or below it (brief §5 - "architecture, not speed" only holds where there
 * is no way around). A single stone wall splits the room in two, with
 * exactly one crossing in it - a Vine tile at row 9, the only row without
 * stone. Holding right alone walks straight into it and stops there for
 * good: the Vine has to be cast-destroyed to open, so the room cannot be
 * brute-forced by movement alone the way an open gap could be.
 *
 * The Drifter steps once every 0.5s while the player walks nearly ten
 * times faster, so simply crossing first is trivial - the room is about
 * the second half. Destroy the Vine, cross, then cast again into the same
 * tile: a fresh block reseals the only route between the two halves before
 * the Drifter arrives, permanently walling it off on the far side.
 * "Outrun it, then wall it off," composing both cast and destroy.
 *
 * SCAFFOLD CONTENT (brief §14), same as Rooms 1-6.
 */
export const pursuit: RoomDef = {
  id: '07-pursuit',
  name: 'Pursuit',
  map: [
    '################',
    '#.......#......#',
    '#.......#......#',
    '#.......#......#',
    '#.......#......#',
    '#.......#......#',
    '#.......#......#',
    '#.......#......#',
    '#.......#......#',
    '#.......~......#',
    '################',
    '################',
  ],
  spawn: { x: 3.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [
    { kind: 'lumen', tx: 11, ty: 9 },
    { kind: 'moonseed', tx: 13, ty: 9 },
  ],
  // Two tiles clear of the spawn tile: a Drifter's first step is immediate
  // (its timer starts at 0), and one tile of separation lands it on the
  // player's own tile - not merely close, but an instant fail on frame one.
  chimera: [{ kind: 'drifter', x: 1, y: 9, dir: 1 }],
};
